import React, {useState} from "react"
import MainHeader from "mainComponents/Header";
import MainFooter from "mainComponents/MainFooter";
import {Heading} from "components";
import {useTranslation} from "react-i18next";
import MainHeaderWithBurger from "components/HeaderButton/headerWithBurgerMain";
import {useNavigate} from "react-router-dom";

export default function ProductsPage() {
    const {t} = useTranslation();

    const navigate = useNavigate();

    const tabs = [
        {
            id: 'products',
            title: t("product.tabs.1.tabsName"),
            tabsTitle: t("product.tabs.1.tabsTitle"),
            tabsDescription: t("product.tabs.1.tabsDescription"),
            content: () =>
                <>
                    <button
                        onClick={() => navigate("/landing")}
                        className={`bg-[#FFB800] hover:bg-[#FFC224] w-[320px] h-[56px] rounded-[12px] items-center justify-center flex`}>
                        <Heading
                            size={"desktop_body_m_bold"}
                            className={`text-[#1B1F3B]`}>
                            {t("product.tabs.1.button")}
                        </Heading>
                        <img
                            src={"/images/arrowRightProductsPage.svg"}
                            alt={"arrow right"}
                            className={`pl-2`}/>
                    </button>
                    <div
                        className={"bg-[#6C6C6C] rounded-[24px] h-[368px] flex justify-center items-center mt-10 sm:mt-8 mb-2 sm:mb-4"}>
                        <img
                            src={"/images/cover.svg"}
                            alt={"Page Logo"}
                            className={"object-contain relative w-[320px] h-[320px]"}/>
                    </div>
                    <div className={`grid lg:grid-rows-1 lg:grid-cols-3 lg:gap-5 grid-cols-2 grid-rows-2`}>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                01
                            </Heading>
                            <Heading
                                size={"desktop_heading_6"}
                                className={`text-[#FFFFFF] uppercase`}>
                                {t("product.tabs.1.contentNumbers.1")}
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A] `}>
                                02
                            </Heading>
                            <Heading
                                size={"desktop_heading_6"}
                                className={`text-[#FFFFFF] uppercase`}>
                                {t("product.tabs.1.contentNumbers.2")}
                            </Heading>
                        </div>
                        <div>
                            <Heading
                                size={"desktop_numeric_l_bold"}
                                className={`text-[#FF573A]`}>
                                03
                            </Heading>
                            <Heading
                                size={"desktop_heading_6"}
                                className={`text-[#FFFFFF] uppercase`}>
                                {t("product.tabs.1.contentNumbers.3")}
                            </Heading>
                        </div>
                    </div>
                </>,
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const renderContent = () => {
        const tab = tabs.find(tab => tab.id === activeTab);
        return tab ? tab.content : null;
    };

    return (
        <div className={"bg-[#B0B0B0] min-h-screen  flex flex-col"}>
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>

            <div
                className={"lg:pb-[160px] md:pb-[100px] sm:pb-[80px] lg:pt-[100px] md:pt-[50px] sm:pt-[80px] lg:px-6 md:px-5 sm:px-4 container-xs"}>

                <div className="flex flex-row md:flex-col sm:flex-col justify-between gap-5 md:gap-[30px] sm:gap-8">

                    {/* Левая часть с табами */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading size={"desktop_heading_2"} className="text-[#191C30E5] whitespace-pre-wrap sm:text-[28px] sm:leading-[120%] sm:uppercase">
                            {t("product.rightTitle")}
                        </Heading>
                        <ul className="mt-10 sm:mt-5 md:flex md:flex-wrap md:gap-2 sm:flex sm:flex-wrap sm:gap-1.5">
                            {tabs.map(tab => (
                                <li key={tab.id}
                                    className={" md:max-w-none sm:max-w-none"}>
                                    <button
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`text-left text-[15px] leading-6 px-3 py-[10px] rounded-md transition-colors duration-200 outline-none ${
                                            activeTab === tab.id
                                                ? "bg-white shadow text-black border border-[#FFB800]"
                                                : "text-gray-700 hover:bg-gray-200 border border-transparent"
                                        }`}
                                    >
                                        {tab.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Правая часть с контентом */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading
                            size={"desktop_heading_5"}
                            className="text-[#191C30E5] uppercase whitespace-pre-line">
                            {tabs.find(tab => tab.id === activeTab)?.tabsTitle}
                        </Heading>
                        <Heading
                            size={"desktop_body_m"}
                            className="text-[#191C30E5] whitespace-pre-line mt-4">
                            {tabs.find(tab => tab.id === activeTab)?.tabsDescription}
                        </Heading>
                        <div className="mt-6">
                            {tabs.find(tab => tab.id === activeTab)?.content()}
                        </div>
                    </div>

                </div>

            </div>

            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>

    );
}